import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from "react-redux";
import * as vignetsActions from "../../actions/vignets";
import {withRouter} from 'react-router';

import { ComposedChart, Area, ResponsiveContainer, Tooltip, XAxis} from 'recharts';
import { BUILDER_PATH, IMGIX_PATH, PUB_PLAYER_PATH } from '../../constants';
import * as userActions from "../../actions/user";


var dateFormat = require('dateformat');

class VignetItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            vignetId: '',
            vignet_name: '',
            selected_class : '',
            graphData : undefined,
            flipClass : ''
        };
        this.selectVigs = this.selectVigs.bind(this);
        this.getVigProps = this.getVigProps.bind(this);
        this.blockDetailView =  this.blockDetailView.bind(this);

    }

    selectVigs(e, vignetId) {

        e.stopPropagation();
        this.setState(prevState => ({
            selected_class: (prevState.selected_class === '')? 'selected' : ''

        }));
        this.props.selectVignets(vignetId);
    }

    getVigProps(vigId){
        let data = { vignet_id : vigId, section : 'list', index : 0, section_name : 'list'};

        this.props.allVignetsProps(data);

    }

    blockDetailView(e, buildUrl) {
        e.preventDefault();
        e.stopPropagation();
        if(this.props.itemType === 'vignets' ) {
            window.open(buildUrl);
        }
    }

    showStatistics(e) {
        e.stopPropagation();
        this.setState({flipClass : 'flip'});

        let id = this.props.detail.uniqueId;

        let startDate = new Date(this.state.fromDate);
        let endDate = new Date(this.state.toDate);
        let fromDate = startDate.toLocaleDateString("en-US");
        let toDate = endDate.toLocaleDateString("en-US")
        let graph_params = { vignetId: id, type: this.state.graphDuration, fromDate: ( fromDate ? fromDate : this.state.fromDate), toDate: ( toDate ? toDate : this.state.toDate), section_name : 'list', index : this.props.id};

        this.props.fetchGraphData(graph_params);
    }

    backToMain(e) {
        e.stopPropagation();
        this.setState({flipClass : ''})
    }


    render() {

        let item = this.props.detail;
        item.selected_class = "";
        console.log(item.uniqueId)
        item.builderUrl = '#';
        item.playerUrl = '#';

        if(this.props.itemType === 'vignets' ) {
            item.builderUrl = BUILDER_PATH+item.uniqueId+'/'+item.user_id;
            item.playerUrl = PUB_PLAYER_PATH+item.uniqueId+'/'+item.user_id;
            item.imgSrc = IMGIX_PATH+'assets/slider/cf'+item.uniqueId+'.jpg?t='+Math.random()+'&fit=crop&h=150&w=150&auto=enhance&dpr=3%203x';
        }


        let graphData =  this.props.vignetsData.graphData?this.props.vignetsData.graphData:[];


        return (
            <div id={'item'+item.uniqueId} className={this.state.flipClass + " panel-block panel-col"} data-id={item.uniqueId} onClick={(e)=> this.selectVigs(e,item.uniqueId)}>
                <div className="face front">
                    <div className="image-upload-block">

                        <div className="image-up" >

                            <img
                                src={item.imgSrc}
                                alt={item.imgSrc}
                                className="my-image" />
                        </div>
                    </div>
                    <div className="title-wrapper edit-title">
                        <h5 className="title-box" >{item.name}</h5>
                    </div>
                    <div className={"description-wrapper " + (this.props.itemType === 'user' ? " no-border" : "")}>
                        <div className="input-desc-block">
                            <span className="description-box">{item.display_name} </span>
                        </div>
                        <div className="input-desc-block">
                            <span className="description-box">{item.date_created ? dateFormat(item.date_created,"d mmm yyyy").toUpperCase() :'' }</span>
                        </div>
                    </div>
                    {this.props.itemType === 'vignets' &&
                    <div className="panel-button-block">
                        <button className="panel-button stat-button" data-id={item.uniqueId} onClick={(e)=> this.showStatistics(e)}>Statistics</button>
                    </div>
                    }
                    {this.props.itemType === 'vignets' &&
                    <button data-id={item.uniqueId}
                            className={this.state.selected_class + " icon-lib-list select-ico"}></button>
                    }
                </div>

                <div className="face back">
                    <div className="stat-header">
                        <h5 className="subheader">{item.name}</h5>
                    </div>
                    <div className="track-count-block">
                        <div className="ind-track-count">
                            <p className="track-text">Click</p>
                            <h5>{item.click_count?item.click_count:0}</h5>
                        </div>
                        <div className="ind-track-count">
                            <p className="track-text">Views</p>
                            <h5>{item.view_count?item.view_count:0}</h5>
                        </div>
                        <div className="ind-track-count btn-track">
                            <a onClick={(e)=> this.blockDetailView(e,item.builderUrl)} href="javascript:;" target="_blank" rel="noopener noreferrer"><button className={"icon-lib edit-button"}></button></a>
                        </div>
                    </div>

                    <div className="track-table">
                        <div className="ind-track-table">
                            <span className="left-graph-text">Page View</span>
                            <span className="right-graph-text">{item.pageview_count?item.pageview_count:0}</span>
                        </div>
                        <div className="ind-track-table">
                            <span className="left-graph-text">HOTSPOT</span>
                            <span className="right-graph-text">{item.hotspot_count?item.hotspot_count:0}</span>
                        </div>
                        <div className="ind-track-table">
                            <span className="left-graph-text">IMAGE CLICK</span>
                            <span className="right-graph-text">{item.imageclick_count?item.imageclick_count:0}</span>
                        </div>
                        <div className="ind-track-table">
                            <span className="left-graph-text">TEXT CLICK</span>
                            <span className="right-graph-text">{item.textclick_count?item.textclick_count:0}</span>
                        </div>
                        <div className="ind-track-table">
                            <span className="left-graph-text">VIDEO</span>
                            <span className="right-graph-text">{item.video_count?item.video_count:0}</span>
                        </div>
                    </div>

                    <div className="chart-block">
                        <ResponsiveContainer width={212} height={46} aspect="width">
                            <ComposedChart  data={graphData} >
                                <Area type="monotone" dataKey="Visits" fill="#45ace3" stroke="#45ace3" />
                                <Tooltip viewBox={{ x: 0, y: 0, width: 400, height: 400 }} active={true} />
                                <XAxis dataKey="name" tick={false}/>
                            </ComposedChart>
                        </ResponsiveContainer>
                    </div>

                    <div className="panel-button-block left-align">
                        <button className="panel-button back-button" onClick={(e)=> this.backToMain(e)}>Back</button>
                    </div>
                </div>
            </div>

        );
    }


}


VignetItem.propTypes = {
    detail: PropTypes.object.isRequired,
    id:PropTypes.number.isRequired,
    selected_ids : PropTypes.array.isRequired,
    showDetailPopup : PropTypes.func
}


function mapStateToProps(state) {
    return {
        vignetsData  :state.vignets.vignetsData,
    };

}
export default  withRouter(connect(mapStateToProps,{
    selectVignets : vignetsActions.chooseVignets,
    allVignetsProps : vignetsActions.getVignetProps,
    fetchGraphData : vignetsActions.fetchGraphData,
    showUserModal : userActions.showUserModal,
})(VignetItem));



// WEBPACK FOOTER //
// ./src/components/playlist/VignetItem.js